// Formatting helpers for currency, percentages and dates (pt-BR).

const BRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const BRL_COMPACT = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatBRL(value: number): string {
  if (!Number.isFinite(value)) return "R$ 0,00";
  return BRL.format(value);
}

export function formatBRLCompact(value: number): string {
  if (!Number.isFinite(value)) return "R$ 0";
  return BRL_COMPACT.format(value);
}

export function formatPercent(value: number, digits = 2): string {
  if (!Number.isFinite(value)) return "0%";
  return `${value.toLocaleString("pt-BR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}

const MONTHS_PT = [
  "jan", "fev", "mar", "abr", "mai", "jun",
  "jul", "ago", "set", "out", "nov", "dez",
];

export function monthLabel(start: Date, offset: number): string {
  const d = new Date(start.getFullYear(), start.getMonth() + offset, 1);
  return `${MONTHS_PT[d.getMonth()]}/${d.getFullYear()}`;
}

export function parseMonthInput(value: string): Date {
  const [y, m] = value.split("-").map(Number);
  if (!y || !m) return new Date();
  return new Date(y, m - 1, 1);
}

export function currentMonthInput(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

const MONTHS_PT_LONG = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

export function formatMonthYearLong(start: Date, offset: number): string {
  const d = new Date(start.getFullYear(), start.getMonth() + offset, 1);
  return `${MONTHS_PT_LONG[d.getMonth()]} de ${d.getFullYear()}`;
}

export function parseCurrencyInput(raw: string): number {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return 0;
  return Number(digits) / 100;
}

export function maskCurrencyInput(value: number): string {
  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatMonths(months: number): string {
  if (months <= 0) return "0 meses";
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const parts: string[] = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? "ano" : "anos"}`);
  if (rest > 0) parts.push(`${rest} ${rest === 1 ? "mês" : "meses"}`);
  return parts.join(" e ") || `${months} meses`;
}

// Aliases for compatibility with the destination project's naming convention
export const removeMask = parseCurrencyInput;
export const normalSanatizerBRL = formatBRL;
